import {
  FormControl,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from '@mui/material';
import tokens from '@verifime/design-tokens';
import { Dispatch, SetStateAction } from 'react';

type TVariant = 'INDIVIDUAL' | 'ORGANISATION';
type TVerifyEntityType = 'INDIVIDUAL' | 'CURRENT_ORGANISATION' | 'SETUP_ORGANISATION';

export default function AdditionalEntityVerificationPrompt({
  initialVerifyEntityType,
  setVerifyEntityType,
  serviceProviderName,
  variant,
}: Readonly<{
  initialVerifyEntityType: TVerifyEntityType;
  setVerifyEntityType: Dispatch<SetStateAction<TVerifyEntityType>>;
  serviceProviderName: string;
  variant: TVariant;
}>) {
  return (
    <Paper sx={{ padding: tokens.spacingSm }}>
      <Stack sx={{ marginBottom: tokens.spacingXs }}>
        <Typography variant="caption" color="textSecondary">
          BEFORE YOU SUBMIT
        </Typography>
        <Typography variant="h6">
          Does {serviceProviderName} need you to verify another entity that you'll be contracting on
          behalf of?
        </Typography>
        <Typography variant="body2" color="textSecondary">
          For example, if you're acting on behalf of a company, trust, SMSF, partnership, or other
          legal entity.{' '}
        </Typography>
      </Stack>
      <FormControl sx={{ paddingLeft: tokens.spacingSm }}>
        <RadioGroup
          name="controlled-radio-buttons-group"
          value={initialVerifyEntityType}
          onChange={(e) => setVerifyEntityType(e.target.value as TVerifyEntityType)}
        >
          {variant === 'INDIVIDUAL' && (
            <FormControlLabel value="INDIVIDUAL" control={<Radio />} label="No" />
          )}
          {variant === 'ORGANISATION' && (
            <FormControlLabel value="CURRENT_ORGANISATION" control={<Radio />} label="No" />
          )}

          <FormControlLabel
            value="SETUP_ORGANISATION"
            control={<Radio />}
            label="Yes, I need to verify another entity"
          />
        </RadioGroup>
      </FormControl>
    </Paper>
  );
}
